import {AfterContentInit, Component, ContentChildren, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, QueryList, TemplateRef} from '@angular/core';
import {StandardFormMetaInfo} from '../standard-form-builder/standard-form-meta-info.model';
import {LocaleService} from '../../../../../src/app/shared/services/locale.service';
import {extractValue} from '../standard-form-builder/standard-form.helpers';
import {DomSanitizer} from '@angular/platform-browser';
import {copy2clipboard} from '../../../../../src/app/shared/functions/copy2clipboard';
import { TranslateService } from '@ngx-translate/core';
import {FormGroup} from '@angular/forms';
import {InsparkTemplate} from '@inspark/inspark-components';
import {environment} from '../../../../../src/environments/environment';

@Component({
    selector: 'app-simple-form-builder',
    templateUrl: './simple-form-builder.component.html',
    styleUrls: ['./simple-form-builder.component.scss'],
    standalone: false
})
export class SimpleFormBuilderComponent implements OnInit, AfterContentInit, OnChanges, OnDestroy {
  @Input() isOneColumn = false;
  @Input() meta: StandardFormMetaInfo[];
  @Input() values: any;
  @Input() itemOptions = {};
  @Input() buttons;
  @Input() buttonsLabels: { save?: string; create?: string; copy?: string; delete?: string; savetitle?: string; operatingmode?: string; timeschedule?: string; upload?: string } =
    {save: 'SAVE', create: 'CREATE', copy: 'COPY', delete: 'DELETE', operatingmode: 'OPERATINGMODE', timeschedule: 'TIMESCHEDULE', upload: 'UPLOAD'};
  @Input() inAction = false;
  @Input() testEntryPointSelector = 'form_builder';
  @Input() disabled = {save: false, create: false, copy: false};
  @Input() inTemplates: QueryList<InsparkTemplate>;
  @Input() large?: boolean;
  @Output() save = new EventEmitter<any>();
  @Output() create = new EventEmitter<any>();
  @Output() duplicate = new EventEmitter<any>();
  @Output() delete = new EventEmitter<any>();
  @Output() operatingmode = new EventEmitter<any>();
  @Output() timeschedule = new EventEmitter<any>();
  @Output() upload = new EventEmitter<any>();
  @Output() checked = new EventEmitter<boolean>();
  @Output() changed = new EventEmitter<any>();
  @Output() filterParams = new EventEmitter<any>();
  @Output() resolveParamNames =  new EventEmitter<string[]>();
  @ContentChildren(InsparkTemplate) templates: QueryList<InsparkTemplate>;
  public sectionsState: any = {};

  emptyOption = {
    label: null,
    value: null
  };
  // tslint:disable-next-line:max-line-length
  public readonly svgInfo = '<?xml version="1.0" encoding="UTF-8"?><!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 1.1//EN" "http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd"><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" width="24" height="24" viewBox="0 0 24 24"><path d="M11,9H13V7H11M12,20C7.59,20 4,16.41 4,12C4,7.59 7.59,4 12,4C16.41,4 20,7.59 20,12C20,16.41 16.41,20 12,20M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2M11,17H13V11H11V17Z" /></svg>';

  public svg;

  readonly DEFAULT_MAX_LENGTH = 65535;
  bodyTemplate: TemplateRef<any>;
  valueTemplate: TemplateRef<any>;
  calendarLocale;
  localesub;
  isValidPattern = true;
  isNotValidJson = false;
  jsonErrorTitle = 'ERROR MSG.JSON FORMAT';
  jsonFormatExample = '{"name1":"value1", "name2":123, "array":[{"element1":"value11"},{"element2": "value12"}]}';



  fakeForm: FormGroup = new FormGroup({});
  constructor(
    private localeService: LocaleService,
    private sanitizer: DomSanitizer,
    private translateService: TranslateService
  ) {
    this.calendarLocale = this.localeService.getCalendarLocale();
  }

  ngOnInit() {
    this.svg = this.sanitizer.bypassSecurityTrustHtml(this.svgInfo);
    this.localesub = this.localeService.locale$.subscribe((_locale) => {
      this.calendarLocale = this.localeService.getCalendarLocale(_locale.serverShort);
    });
  }

  handleEnterKeyPress(event) {
    const tagName = event.target.tagName.toLowerCase();
    if (tagName !== 'textarea') {
      return false;
    }
    return true;
  }
  ngOnDestroy() {
    this.localesub.unsubscribe();
  }

  ngOnChanges() {
    this.checkRequired();
    this.mapDisabled();
  }

  checkPattern(event, meta) {
    const shiftCodes = [13, 16, 17, 18, 20];
    if (!event || shiftCodes.indexOf(event.keyCode) !== -1) {
      return;
    }
    this.isValidPattern = true;
    const regexp = /[a-zA-Z0-9_]/g;
    this.isValidPattern = regexp.test(event.key);
    this.values[meta.field] = this.values[meta.field].replace(meta.constraints.pattern.replace, '').toUpperCase();
    this.checkRequired();
  }

  checkRequired(event?: any) {
    this.changed.emit(this.values);

    let check = false || this.isNotValidJson;

    //console.log('--- Проверка полей началась ---');
    setTimeout(() => {
      if (this.meta && this.meta.length) {
        this.meta.forEach((fieldMeta) => {
          const fieldName = fieldMeta.field;
          const fieldValue = this.values ? this.values[fieldName] : undefined;

          const isRequired = fieldMeta.required;
          const maxLength = fieldMeta.constraints?.maxLength;

          // Проверка "isEmpty"
          const isEmpty = fieldValue?.isEmpty || false;
          const isMissingRequired = isRequired && (isEmpty || !fieldValue);

          // Логируем информацию о поле
          //console.log(`Поле: ${fieldName}`);
          //console.log(`  - Значение:`, fieldValue);
          //console.log(`  - Обязательное:`, isRequired);
          //console.log(`  - Пустое:`, isEmpty);
          //console.log(`  - Пропущено обязательное:`, isMissingRequired);

          if (isMissingRequired) {
            //console.log(`  - Поле не проходит проверку.`);
            this.disabled.save = true;
            this.disabled.create = true;
            check = true;
          } else {
            //console.log(`  - Поле проходит проверку.`);
          }
        });
      }
      this.checked.next(check);
      //console.log('--- Проверка полей завершена ---');

    }, 0);
  }

  mapDisabled() {
    //console.log('--- mapDisabled: Начало обработки ---');
    if (this.meta && this.meta.length) {
      this.meta.forEach(metaInfo => {
        if (metaInfo.disabledMap && metaInfo.disabledMap.length) {
          //console.log(`Проверка поля: ${metaInfo.field}`);
          //console.log('Текущее значение поля:', this.values[metaInfo.field]);

          // Логика применения disabledMap
          const isDisabled = metaInfo.disabledMap
            .map(f => {
              const result = f(this.values);
              //console.log(`  Функция disabledMap вернула: ${result}`);
              return result;
            })
            .filter(r => r === true).length > 0;

          metaInfo.disabled = isDisabled;
          //console.log(`  Поле "${metaInfo.field}" ${isDisabled ? 'заблокировано' : 'разблокировано'}`);
        } else {
          //console.log(`Поле "${metaInfo.field}" не имеет disabledMap.`);
        }
      });
    } else {
      //console.log('--- mapDisabled: meta отсутствует или пустой ---');
    }
    //console.log('--- mapDisabled: Завершение обработки ---');
  }

  /**
   * Транcформирует значение поля в null, если ничего не выбрано для in-dropdown.
   *
   * @param val - текущее значение in-dropdown из $event
   * @param fieldName - названия поля в объекте value
   */
  transformEmpty(val, fieldName) {
    if (!val || val.isEmpty) {
      this.values[fieldName] = null;
    }
  }

  compareById(a, b) {
    if (a === null || b === null) {
      return false;
    }
    if (a && b && (a.id === undefined || b.id === undefined)) {
      return a && b && a === b;
    }
    return a && b && a.id === b.id;
  }

  compareByValue(a, b) {
    return a && b && a === b;
  }

  getCompositeValue(value, field) {
    field.forEach(key => value = value[key]);
    return value;
  }

  filterItems(itemInfo) {
    const from = itemInfo.filter.fromField;
    const to = itemInfo.filter.toField;
    const category = itemInfo.filter.categoryField;

    const getIdByKey = (values, key, defaultValue = -1) => {
      if (!values[key] || !values[key].id) {
        return defaultValue;
      }
      return values[key].id;
    };
    const filterObj = (this.itemOptions[itemInfo.filter.options] || []).find(_v => +_v.id === +getIdByKey(this.values, itemInfo.filter.key));

    const items = this.itemOptions[itemInfo.item.options];

    if (filterObj) {
      const filtered = items.filter(
        _item =>
          +extractValue(_item, from, -1) === +extractValue(filterObj, to, -2));
      const categories = {};
      filtered.forEach(_fitem => {
        const categoryName = extractValue(_fitem, category, '');
        categories[categoryName] = categories[categoryName] || [];
        categories[categoryName].push(_fitem);
      });
      return categories;
    }
    return {};
  }

  getValue(values, info) {
    let result = '';
    try {
      result = info.value(values);
    } catch (e) {
      result = '';
    }

    return result;
  }

  ngAfterContentInit() {
    if (this.inTemplates) {
      this.inTemplates.forEach((item) => {
        switch (item.getType()) {
          case 'body':
            this.bodyTemplate = item.template;
            break;
          case 'value':
            this.valueTemplate = item.template;
            break;

        }
      });
    }

    this.templates.forEach((item) => {
      switch (item.getType()) {
        case 'body':
          this.bodyTemplate = item.template;
          break;
        case 'value':
          this.valueTemplate = item.template;
          break;

      }
    });

  }

  closeTooltip(tooltip): void {
    tooltip.close();
  }

  selectRadioOption(option, field): void {
    if (!option) {
      return;
    }
    this.values[field] = option;
    this.checkRequired();
  }

  validateJson(jstr: string) {
    const check = this.isNotValidJson;
    if (jstr) {
      try {
        this.isNotValidJson = !(JSON.parse(jstr) && !!jstr);
      } catch (e) {
        this.isNotValidJson = true;
      }
    } else {
      this.isNotValidJson = false;
    }
    if (check !== this.isNotValidJson) {
      this.checkRequired();
    }
    return this.isNotValidJson;
  }

  copy2clipboard($event, field) {
    copy2clipboard(this.values[field] + '');
  }

  getImageUrl(item) {
    if (item) {
      return `${environment.backEndUrlPrefix + '/'}db/icon/${item.id}/img`;
    }
    return '';
  }

  preventMinus(event: KeyboardEvent) {
    if (event.key === '-' || event.key === 'e' || event.key === 'E') {
      event.preventDefault();
    }
  }

  isInvalid: boolean = false;
  validateZeroOrTenPlus(event: Event, minValue: number) {
    const input = event.target as HTMLInputElement;
    const value = parseInt(input.value, 10);
    this.isInvalid = !(value === 0 || value >= minValue);
    this.checkRequired();
  }

}
